import { deviceUtil } from "@repo/lib-common";
import { AdLoadingStrategyTypeEnum, AdSizes, AdUnit, AdUnitSpecialUseCaseEnum, AdUnitTypeEnum } from "@repo/lib-domain-tag";
export const nativoAdUnits = [
    //#region nativo index 1
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.allDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.nativo)
        .setSpecialUseCaseIndex(1)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/nativo1")
        .setDivId("div-nativo1")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_And_Mobile_Nativo)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(false)
        .setPrebidSizeLimits([])
    //.setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region nativo index 2
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.allDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.nativo)
        .setSpecialUseCaseIndex(2)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/nativo2")
        .setDivId("div-nativo2")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_And_Mobile_Nativo)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(false)
        .setPrebidSizeLimits([])
    //.setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region nativo index 3
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.allDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.nativo)
        .setSpecialUseCaseIndex(1)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/nativo3")
        .setDivId("div-nativo3")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_And_Mobile_Nativo)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(false)
        .setPrebidSizeLimits([])
    //.setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region nativo index 4
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.allDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.nativo)
        .setSpecialUseCaseIndex(4)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/nativo4")
        .setDivId("div-nativo4")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_And_Mobile_Nativo)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(false)
        .setPrebidSizeLimits([])
    //.setBidderHelper(pageBidderHelper)

    ,
    //#endregion



    //#region nativo index 5
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.allDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.nativo)
        .setSpecialUseCaseIndex(5)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/nativo5")
        .setDivId("div-nativo5")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_And_Mobile_Nativo)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(false)
        .setPrebidSizeLimits([])
    //.setBidderHelper(pageBidderHelper)

    ,
    //#endregion

    //#region nativo index 6
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.allDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.nativo)
        .setSpecialUseCaseIndex(6)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/nativo6")
        .setDivId("div-nativo6")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_And_Mobile_Nativo)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(false)
        .setPrebidSizeLimits([])
    //.setBidderHelper(pageBidderHelper)

    ,
    //#endregion
]